export default function AlertTriangle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...(props || {})}
    >
      <g id="alert triangle">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.98302 5.26036C10.4106 4.55547 11.1752 4.125 11.9996 4.125C12.824 4.125 13.5886 4.55547 14.0185 5.2641L20.6839 16.3918C21.103 17.1175 21.1055 18.0111 20.6905 18.7392C20.2755 19.4673 19.5053 19.9204 18.6587 19.9297L5.33189 19.9297C4.49389 19.9204 3.72372 19.4673 3.30872 18.7392C2.89372 18.0111 2.89622 17.1175 3.32168 16.3809L9.98302 5.26036ZM12.6718 6.07585C12.5293 5.84088 12.2744 5.69739 11.9996 5.69739C11.7248 5.69739 11.4699 5.84088 11.3297 6.07211L4.67697 17.1781C4.53728 17.42 4.53644 17.7178 4.67478 17.9605C4.81311 18.2032 5.06984 18.3543 5.34053 18.3573L18.6501 18.3574C18.9294 18.3543 19.1861 18.2032 19.3244 17.9605C19.4628 17.7178 19.4619 17.42 19.3286 17.1889L12.6718 6.07585ZM11.9996 8.92295C12.4028 8.92295 12.7351 9.22646 12.7805 9.61746L12.7858 9.70915V12.8539C12.7858 13.2881 12.4338 13.6401 11.9996 13.6401C11.5964 13.6401 11.2641 13.3366 11.2187 12.9456L11.2134 12.8539V9.70915C11.2134 9.27495 11.5654 8.92295 11.9996 8.92295ZM12.7937 15.9987C12.7937 15.5645 12.4417 15.2125 12.0075 15.2125L11.9079 15.2178C11.5169 15.2632 11.2134 15.5955 11.2134 15.9987C11.2134 16.4329 11.5654 16.7849 11.9996 16.7849L12.0992 16.7796C12.4902 16.7342 12.7937 16.4019 12.7937 15.9987Z"
        />
      </g>
    </svg>
  );
}
